import parse from 'html-react-parser';
import React, { useContext } from "react";
import {cleanJobTitle, buildJobURL, cleanJobDescHTML, removeMainCat, formatDate} from '../helpers/helpers.js';
import { Context } from "./jobs-wrapper";

const JobDetail = () => {
    const { jobDetail, loading } = useContext(Context);
    //console.log("Job detail Name: " + JSON.stringify(name))

    if (typeof jobDetail !== 'undefined') {
        return (
            <div class="col-lg-6" id="job-detail">
                {(Object.entries(jobDetail).length>0 && !loading)  && (
                
                    <div class="job_results__details-outer">
                        <div class="job_results__details-inner">
                            <div class="job_results__details">
                                <div class="job_results__details-header">
                                    <h3 class="blue meta-title">{cleanJobTitle(jobDetail['job_title'][0])}</h3>
                                    
                                    <a href={buildJobURL(jobDetail['job_category'][0], jobDetail['job_city'][0], jobDetail['job_state_abbr'][0], jobDetail['job_postal'][0], jobDetail['job_order_id'][0])} title="Apply" class="btn">Apply</a>
                                </div>
                                <div class="job_results__details-content">
                                    <h4 class="blue">Job Details</h4>
                                    <div class="meta">
                                        <div class="meta__info"><span>Location</span> {jobDetail['job_city'][0]}, {jobDetail['job_state_abbr'][0]}</div>
                                        <div class="meta__info"><span>Discipline</span> {removeMainCat(jobDetail['job_category'][0])}</div>
                                        <div class="meta__info"><span>Date Posted</span> {formatDate(jobDetail['modified_at'][0])}</div>
                                    </div>
                                    <h4 class="blue">Job Description</h4>
                                    {parse(cleanJobDescHTML(jobDetail['job_description'][0]))}
                                    <div class="eeo">
                                        <p class="small">Sunbelt is an equal opportunity employer. We consider applicants for all positions without discrimination on the basis of race, color, religion, sex, national origin, age, marital or veteran status, disability, or any other legally protected status. No question on the website is used for the purpose of limiting or excluding any applicant’s consideration for employment on any basis prohibited by local, state, or federal law.</p>
                                    </div>
                                </div>
                            </div>
                            <a href="/quick-apply/" class="simple-green-tout" title="Quick Apply">
                                <h3>Haven’t Found The Right Fit?</h3>
                                <h5>Submit your resume and we’ll find a place for you to shine.</h5>
                                <span class="link-arrow-white">Quick Apply</span>
                            </a>
                        </div>
                    </div>
    
                )}
            </div>    
        )
    }
        
    
}

export default JobDetail